export default function StatsSection() {
  return (
    <section className="py-16 md:py-20 px-4 md:px-6 lg:px-8 bg-background-50">
      <div className="max-w-5xl mx-auto">
        <div className="flex flex-col lg:flex-row gap-12 lg:gap-16 items-start">
          <div className="lg:w-1/3 shrink-0">
            <span className="text-xs font-label text-foreground-500 uppercase tracking-widest">
              Independent Resource
            </span>
            <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950 mt-3 leading-tight">
              Why Thousands of Buyers Use Kakobuy Spreadsheet
            </h2>
          </div>

          <div className="lg:w-2/3">
            <p className="text-foreground-700 text-sm md:text-base leading-relaxed">
              The <strong>Kakobuy Spreadsheet</strong> has become the go-to resource for savvy shoppers worldwide. Unlike random Yupoo browsing, our curated directory brings together verified sellers, real-time price comparisons, and detailed product information into one easy-to-navigate platform. Whether you are hunting for the latest sneaker releases, premium streetwear, or luxury accessories, the <strong>Kakobuy Spreadsheet</strong> saves you hours of searching and helps you avoid unreliable sellers. With over 20,000 products cataloged across 14 categories, every listing is reviewed by our team of spreadsheet experts to ensure accuracy, fair pricing, and seller reliability. Our commitment to daily updates means you are always seeing the freshest deals and newest product arrivals from trusted Yupoo sellers.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-8 mt-14">
          <div className="text-center p-6 rounded-xl bg-background-100">
            <p className="font-heading font-extrabold text-3xl md:text-4xl text-foreground-950">20,000<span className="text-primary-500">+</span></p>
            <p className="text-xs md:text-sm text-foreground-600 mt-2 font-label">Products Listed</p>
          </div>
          <div className="text-center p-6 rounded-xl bg-background-100">
            <p className="font-heading font-extrabold text-3xl md:text-4xl text-foreground-950">500<span className="text-accent-500">+</span></p>
            <p className="text-xs md:text-sm text-foreground-600 mt-2 font-label">Trusted Sellers</p>
          </div>
          <div className="text-center p-6 rounded-xl bg-background-100">
            <p className="font-heading font-extrabold text-3xl md:text-4xl text-foreground-950">100<span className="text-primary-500">%</span></p>
            <p className="text-xs md:text-sm text-foreground-600 mt-2 font-label">Free Access</p>
          </div>
          <div className="text-center p-6 rounded-xl bg-background-100">
            <p className="font-heading font-extrabold text-3xl md:text-4xl text-foreground-950">365</p>
            <p className="text-xs md:text-sm text-foreground-600 mt-2 font-label">Days Updated</p>
          </div>
        </div>
      </div>
    </section>
  );
}